import * as React from "react";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextPage } from "next";
import Layout from "@/components/layout";
import Image from "next/image";
import styles from "./index.module.scss";
import Head from "next/head";
import AboutBanner from "@images/aboutBanner.png";
import AboutMBg from "@images/aboutMBg.png";
import AboutMissing from "@images/aboutMissing.png";
import AboutBottom from "@images/aboutBottom.png";
import { useTranslation } from 'next-i18next'
const About: NextPage<{
  context: any;
}> = (props) => {
  const { t } = useTranslation(["about"])
  return (
    <div className="bg-[#fff]">
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("seo about title")}</title>
          <meta
            name="keywords"
            content={t("seo about keywords")}
          />
          <meta
            name="description"
            content={t("seo about description")}
          />
        </Head>
        <div className={styles.about}>
          <div className={styles.banner}>
            <div className={`defeaultContainer ${styles.top}`}>
              <div className={`flex  justify-between ${styles.topwrap}`}>
                <div className={styles.left}>
                  <h1 className={styles.title}>{t('bannerTitle')}</h1>
                  <h2 className={styles.tip}>
                  {t('bannerTip')}
                  </h2>
                </div>
                <div className={`${styles.right} animate-box`}>
                  <div className={styles.pic}>
                    <Image alt="" src={AboutBanner}></Image>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`defeaultContainer ${styles.missing}`}>
            <div className={styles.missingPic}>
              <Image alt="" src={AboutMissing}></Image>
            </div>
            <div className={styles.missingContent}>
              <p className={styles.missingTitle}>{t('missingTitle')}</p>
              <div className={styles.missingTip}>
              {t('missingTip')}
              </div>
            </div>
          </div>
          <div className={styles.team}>
            <div className={styles['bg-green']}></div>
            <div className={styles.mbg}>
              <Image src={AboutMBg} alt=""></Image>
            </div>
            <div className={styles.teamContent + ' defeaultContainer'}>
              <div className={styles.teamTitle}>{t('teamTitle')}</div>
              <div className={styles.teamTip}>
              {t('teamTip')}
              </div>
            </div>
            <div className={styles.teamBottom}>
            <span className={styles.teamBottomText}>{t('teamBottom')}</span>
            <div className={styles.teamBottomPic}>
              <Image src={AboutBottom} alt=""></Image>
            </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
        "about"
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
    },
  };
};
export default About;
